<template>
  <div v-if="show" class="verify-email-modal">
    <div @click="closeModal" class="verify-email-modal-close close"></div>
    <div   class="verify-email-modal-content">
      <div class="verify-email-modal-content-headline">
        <span>{{headline}}</span>
      </div>
      <div v-if="!success_verified" class="verify-email-modal-content-email">
        <label>
          <input :class="{error: email_error_show}" v-model="email" type="text" :disabled="!editEmail" />
          <div class="verify-email-modal-content-email-error" v-if="email_error_show">
            {{trans('email_already_taken')}}
          </div>
        </label>
        <button @click="editEmail = true" v-if="!editEmail" class="verify-email-modal-content-email-edit"></button>
        <button @click="updateProfileEmail" v-if="editEmail" class="verify-email-modal-content-email-update"></button>
        <button @click="cancelEditEmail" v-if="editEmail" class="verify-email-modal-content-email-cancel"></button>
      </div>
      <div class="verify-email-modal-content-text">
        {{description}}
      </div>
      <div v-if="!success_verified" :class="{'verify-email-modal-content-code':true, 'big-margin': !resendCodeStatus}">
        <input type="text" v-model="code" />
      </div>
      <transition name="slide-up">
        <div v-if="resendCodeStatus && !success_verified" :class="{'verify-email-modal-content-resend-status': true, 'green' : resendCodeStatusColor === 'green', 'red' : resendCodeStatusColor === 'red'}">
          {{resendCodeStatus}}
        </div>
      </transition>
      <div v-if="!success_verified" @click="resendCode" :class="{'verify-email-modal-content-resend':true,'load': load_resend}">
        {{resendCodeTitle}}
      </div>
      <div class="verify-email-modal-content-footer">
        <button id="button5" :disabled="editEmail" @click="submit" class="btn  btn-100" :class="{'btn-primary':true}">{{buttonTitle}}</button>

        <div v-if="verify_error" class="verify-email-modal-content-footer-error">
          {{verify_error}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapState, mapGetters} from 'vuex';
import Login from "@buddy/views/new/widgets/Login";
import axios from "axios";
import chatModule from "../../../chat/module/store/type";
import $ from "jquery";

export default {
  components: {
  },
  mixins: [require('@general/lib/mixin').default],
  methods: {
    ...mapActions([

    ]),
    closeModal(){
      this.success_verified = false;
      this.code = '';
      this.closeVerifyEmailModal();
    },
    cancelEditEmail(){
      this.editEmail = false;
      this.email = this.userProfile.email;
      this.email_error_show = false;
    },
    async resendCode(){
      this.load_resend = true;
      if(this.block_resend_till){
        return false;
      }
      let response = await axios.post('/api/resendEmailVerificationCode', {})
      if (response.status === 200) {
        this.current_time = moment()
        let self = this;
        self.load_resend = null;
        let interval = setInterval(function (){
          self.current_time = moment();
          if(self.formatTime < 1){
            clearInterval(interval);
            self.block_resend_till = null;
            self.resendCodeStatus = null;
          }
        }, 1000)
        let data = response.data;
        this.block_resend_till = data.next_sent_available;
        if(data.status === 'sent'){
          this.resendCodeStatus = this.trans('code_was_sent')
          this.resendCodeStatusColor = 'green';
        }else{
          this.resendCodeStatus = this.trans('code_was_not_sent');
          this.resendCodeStatusColor = 'red';
        }
      }
    },
    updateProfileEmail(event){
      this.saveProfileChange(event, true, {email:this.email})
      if(this.userProfile.email !== this.email){
        this.email_error_show = true;
      }else{
        this.editEmail = false;
      }
    },
    async submit(){
      if(this.success_verified){
        this.closeModal();
        return false;
      }
      this.showLoadingButton('#button5')
      await this.sendSubmitRequest();
    },
    async sendSubmitRequest(){
      let response = await axios.post('/api/verifyEmail', {
        code: this.code,
        token: this.$route.query.verify_token
      })
      if (response.status === 200) {
        let data = response.data;
        if(data.error){
          this.verify_error = this.trans(data.error)
        }else{
          this.$store.commit('updateUser', {email_verified: true})
          this.success_verified = true;
        }
        $('#button5').find('span.hidden').text(this.trans('ok'));
        this.restoreLoadingButton('#button5')
      }
    }
  },
  computed: {
    ...mapGetters([
      'userProfile'
    ]),
    resendCodeTitle(){
      return this.block_resend_till ? this.trans('code_can_be_sent_after',{time: this.formatTime}) : this.trans('resend_email_code')
    },
    formatTime(){
      const moment1 = moment(this.block_resend_till);
      const moment2 = this.current_time;

      return moment2.diff(moment1, 'seconds') * (-1);
    },
    headline() {
      return this.success_verified ? this.trans('payment.thank_you') : this.trans('verify_your_email');
    },
    description() {
      return this.success_verified ? 'Email verified successfully!' :  this.trans('verify_your_email_description');
    },
    buttonTitle(){
      return this.success_verified ? this.trans('ok') : this.trans('verify');
    },
    ...mapState({
      show: state => state.modal.verify_email,
    }),
  },
  data(){
    return {
      editEmail : null,
      email: '',
      email_error_show: null,
      block_resend_till: null,
      resendCodeStatus: null,
      current_time: null,
      resendCodeStatusColor: null,
      load_resend: false,
      code: null,
      verify_error: null,
      success_verified: null
    }
  },
  mounted() {
    this.email = this.userProfile.email;
    if(this.$route.query.verify_email && this.$route.query.verify_token){
      this.sendSubmitRequest();
    }else{
      //this.resendCode()
    }
  }
}
</script>
